import { read, create } from '@/api/rest';

const me = {
  index: async () => await read('/me'),
  role: async () => await read('/me/role'),
  person: async () => await read('/me/person'),
  changePartnerVisibility: async () =>
    await create('/me/change-partner-visibility'),
};

export default me;
